import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgTimelineEvent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M81.88 20.125H23.216a2.717 2.717 0 0 0-2.717 2.717v74.965c0 1.5 1.216 2.717 2.717 2.717H81.88c1.5 0 2.717-1.217 2.717-2.717V22.842c0-1.5-1.216-2.717-2.717-2.717Z"
        fill="#F1F5F9"
      />
      <path
        d="M23.217 20.125H81.88a2.716 2.716 0 0 1 2.717 2.717v3.132H20.5v-3.132a2.716 2.716 0 0 1 2.717-2.717Z"
        fill="#78B441"
      />
      <path
        d="M24.107 23.936a.89.89 0 1 0 0-1.78.89.89 0 0 0 0 1.78ZM27.673 23.936a.89.89 0 1 0 0-1.78.89.89 0 0 0 0 1.78ZM31.24 23.936a.89.89 0 1 0 0-1.78.89.89 0 0 0 0 1.78Z"
        fill="#599F40"
      />
      <path d="M27.794 32.644v67.88h-1.6v-67.88h1.6Z" fill="#CCD5E1" />
      <path
        d="M26.994 34.091a1.447 1.447 0 1 0 0-2.894 1.447 1.447 0 0 0 0 2.894Z"
        fill="#F1F5F9"
      />
      <path
        d="M27.64 32.645a.647.647 0 1 0-1.294 0 .647.647 0 0 0 1.295 0Zm1.6 0a2.246 2.246 0 1 1-4.492-.001 2.246 2.246 0 0 1 4.492 0ZM26.994 40.136a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4Z"
        fill="#CCD5E1"
      />
      <path
        d="M26.993 39.337a.1.1 0 0 0-.1.1l.009.038a.1.1 0 1 0 .13-.13l-.039-.008Zm1.5.1a1.5 1.5 0 1 1-3-.001 1.5 1.5 0 0 1 3 0ZM26.994 45.57a.7.7 0 1 0 0-1.399.7.7 0 0 0 0 1.4Z"
        fill="#CCD5E1"
      />
      <path
        d="M26.993 44.77a.1.1 0 0 0-.1.1l.009.04a.1.1 0 1 0 .13-.131l-.039-.008Zm1.5.1a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM26.994 89.649a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4Z"
        fill="#CCD5E1"
      />
      <path
        d="M26.993 88.85a.1.1 0 0 0-.1.099l.009.039a.1.1 0 1 0 .13-.131l-.039-.008Zm1.5.099a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM26.994 95.083a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4Z"
        fill="#CCD5E1"
      />
      <path
        d="M26.993 94.283a.1.1 0 0 0-.1.1l.009.039a.1.1 0 1 0 .13-.13l-.039-.009Zm1.5.1a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM48.024 30.505H33.046c-.75 0-1.358.608-1.358 1.358v1.556c0 .75.608 1.358 1.358 1.358h14.978c.75 0 1.359-.608 1.359-1.358v-1.556c0-.75-.608-1.358-1.359-1.358ZM77.09 38.058H33.073c-.765 0-1.385.619-1.385 1.382 0 .764.62 1.383 1.385 1.383H77.09c.766 0 1.386-.62 1.386-1.383s-.62-1.382-1.386-1.382ZM77.09 43.492H33.073c-.765 0-1.385.619-1.385 1.382 0 .764.62 1.383 1.385 1.383H77.09c.766 0 1.386-.62 1.386-1.383s-.62-1.382-1.386-1.382Z"
        fill="#CCD5E1"
      />
      <path
        d="M26.994 83.603a1.447 1.447 0 1 0 0-2.894 1.447 1.447 0 0 0 0 2.894Z"
        fill="#F1F5F9"
      />
      <path
        d="M27.64 82.157a.647.647 0 1 0-1.294 0 .647.647 0 0 0 1.295 0Zm1.6 0a2.246 2.246 0 1 1-4.492 0 2.246 2.246 0 0 1 4.492 0ZM48.024 80.023H33.046c-.75 0-1.358.609-1.358 1.359v1.555c0 .75.608 1.36 1.358 1.36h14.978c.75 0 1.359-.61 1.359-1.36v-1.555c0-.75-.608-1.359-1.359-1.359ZM77.09 87.57H33.073c-.765 0-1.385.62-1.385 1.383s.62 1.382 1.385 1.382H77.09c.766 0 1.386-.62 1.386-1.382 0-.764-.62-1.383-1.386-1.383ZM77.09 93.004H33.073c-.765 0-1.385.62-1.385 1.383s.62 1.382 1.385 1.382H77.09c.766 0 1.386-.619 1.386-1.382 0-.764-.62-1.383-1.386-1.383Z"
        fill="#CCD5E1"
      />
      <path
        d="M93.148 49.83H34.486a2.717 2.717 0 0 0-2.717 2.717v21.18c0 1.5 1.217 2.717 2.717 2.717h58.662c1.501 0 2.718-1.217 2.718-2.717v-21.18c0-1.5-1.217-2.717-2.718-2.717Z"
        fill="#fff"
      />
      <path d="M39.063 50.122v26.322h-1.6V50.122h1.6Z" fill="#A6DBCB" />
      <path d="M38.263 58.361a1.447 1.447 0 1 0 0-2.893 1.447 1.447 0 0 0 0 2.893Z" fill="#fff" />
      <path
        d="M38.91 56.915a.647.647 0 1 0-1.295 0 .647.647 0 0 0 1.295 0Zm1.6 0a2.246 2.246 0 1 1-4.493 0 2.246 2.246 0 0 1 4.492 0Z"
        fill="#A6DBCB"
      />
      <path
        d="M95.065 52.547a1.917 1.917 0 0 0-1.917-1.917H34.486a1.917 1.917 0 0 0-1.917 1.916v21.18c0 1.059.858 1.917 1.917 1.917h58.662a1.917 1.917 0 0 0 1.917-1.917v-21.18Zm1.6 21.18a3.518 3.518 0 0 1-3.517 3.517H34.486a3.517 3.517 0 0 1-3.517-3.518v-21.18a3.517 3.517 0 0 1 3.517-3.516h58.662a3.517 3.517 0 0 1 3.518 3.517v21.18Z"
        fill="#0F172A"
      />
      <path
        d="M59.293 54.782H44.316c-.75 0-1.36.608-1.36 1.358v1.556c0 .75.61 1.358 1.36 1.358h14.977c.75 0 1.359-.608 1.359-1.358V56.14c0-.75-.608-1.358-1.359-1.358Z"
        fill="#A6DBCB"
      />
      <path
        d="M88.36 62.328H44.343c-.766 0-1.386.62-1.386 1.383s.62 1.382 1.386 1.382H88.36c.765 0 1.385-.619 1.385-1.382 0-.764-.62-1.383-1.385-1.383ZM88.36 67.763H44.343c-.766 0-1.386.618-1.386 1.382 0 .763.62 1.382 1.386 1.382H88.36c.765 0 1.385-.619 1.385-1.382 0-.763-.62-1.382-1.385-1.382Z"
        fill="#E6F4F0"
      />
      <path d="M38.263 64.407a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4Z" fill="#A6DBCB" />
      <path
        d="M38.263 63.607a.1.1 0 0 0-.1.1l.008.039a.1.1 0 1 0 .13-.13l-.038-.009Zm1.5.1a1.5 1.5 0 1 1-3.001 0 1.5 1.5 0 0 1 3 0ZM38.263 70.52a.7.7 0 1 0 0-1.399.7.7 0 0 0 0 1.4Z"
        fill="#A6DBCB"
      />
      <path
        d="M38.263 69.72a.1.1 0 0 0-.1.1l.008.04a.1.1 0 1 0 .13-.132l-.038-.007Zm1.5.1a1.5 1.5 0 1 1-3.001 0 1.5 1.5 0 0 1 3 0Z"
        fill="#A6DBCB"
      />
      <path
        d="M104.251 43.06a.8.8 0 0 1 1.053 1.204l-4.456 3.899a.8.8 0 0 1-1.053-1.204l4.456-3.9ZM105.081 50.15a.8.8 0 0 1 .506 1.518l-3.342 1.115a.799.799 0 1 1-.505-1.518l3.341-1.114ZM96.85 41.58a.8.8 0 0 1 1.373.822l-1.672 2.785a.8.8 0 1 1-1.371-.823l1.67-2.784Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgTimelineEvent)
